import React from "react";
import Hero from "../components/Hero";
import PackConsensus from "../components/PackConsensus";
import RiskGovernance from "../components/RiskGovernance";
import OnChainExecution from "../components/OnChainExecution";

export function HomePage({ config }) {
  return (
    <div className="bg-gray-900">
      <Hero config={config} />
      <PackConsensus />
      <RiskGovernance />
      <OnChainExecution />
    </div>
  );
}
